<template>
  <div class="common-layout">
    <Header></Header>
    <router-view></router-view>

    <el-container>
      <!-- <el-header>
        <div>

        </div>
        <template v-if="!isLogin">
          <n-button type="primary" size="large" style='margin-right:10px;' @click="showLoginModal = true">登录</n-button>
          <n-button type="primary" size="large" @click="showRegisterModal = true">注册</n-button>
        </template>
        <router-link :to="0 || '/cyds/signup'">
          我要报名
        </router-link>
      </el-header> -->
    </el-container>
    <Footer></Footer>
  </div>
</template>

<script setup>
import {
  ref,
  nextTick,
  onMounted,
  onBeforeUnmount,
  computed,
  reactive,
  defineEmit,
  useContext,
  watch,
} from 'vue';
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import SingleUploadFace from "@/components/single-upload/mainFace";
import { ElMessage } from 'element-plus'
import Login from './components/Login.vue';
import { useStore } from 'vuex';
import { getUserInfoApi, uploadRacePhotos } from '@/api/cyds';
const store = useStore();
const isLogin = computed(() => Boolean(store.state.cydstoken));




</script>

<style>
</style>